<template><div><h1>VUX V2.2.1Rc.2 发布日志</h1>
<h2><a href="/zh-CN/components/badge.html">Badge</a></h2>
<ul><li>[fix] 修复个位数字样式不正确 #1223</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] 可以点击下个月日期并自动切换到下个月 #1192</li>
<li>[fix] 修复 start-date 和 end-date 变化后不重新渲染的问题 #1219</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] 如果初始化时获取不到宽度则直接使用视口宽度 #1188</li>
<li>[fix] 修复初始化时 index > 0 不生效</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.2 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.2-221.vue?4ad28a34